/* Aleph Male cart drawer extras: free-shipping progress bar, one-tap add-on, open drawer after add to cart. */
import { CartUpdateEvent } from '@theme/events';

/*
 * Free-shipping thresholds, per shipping country, matching the rates set in Shopify:
 * United States: orders of $100 or more. Israel: the rate is set at $84, shown to shoppers as 270 shekels.
 */
const FREE_SHIPPING = {
  US: { amount: 100, currency: 'USD', usd: 100 },
  IL: { amount: 270, currency: 'ILS', usd: 87 },
};

/* The theme's cart drawer opens itself after an add to cart when it carries this attribute. */
const enableAutoOpen = () => {
  document.querySelectorAll('cart-drawer-component').forEach((drawer) => drawer.setAttribute('auto-open', ''));
};
enableAutoOpen();
document.addEventListener(CartUpdateEvent.eventName, enableAutoOpen);

class AmShipBar extends HTMLElement {
  static get observedAttributes() {
    return ['data-total'];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  render() {
    const root = this.shadowRoot || this.attachShadow({ mode: 'open' });
    const shopify = window.Shopify || {};
    const rule = FREE_SHIPPING[shopify.country];
    if (!rule) {
      root.innerHTML = '';
      this.hidden = true;
      return;
    }
    this.hidden = false;

    const rate = Number(shopify.currency && shopify.currency.rate) || 1;
    const currency = (shopify.currency && shopify.currency.active) || 'USD';
    const threshold = currency === rule.currency ? rule.amount * 100 : Math.round(rule.usd * rate * 100);
    const total = Number(this.dataset.total) || 0;
    const left = Math.max(0, threshold - total);
    const pct = Math.min(100, Math.round((total / threshold) * 100));
    const he = (this.dataset.lang || '').indexOf('he') === 0;

    let amount = '';
    try {
      amount = new Intl.NumberFormat(he ? 'he-IL' : 'en-US', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: left % 100 === 0 ? 0 : 2,
      }).format(left / 100);
    } catch (e) {
      amount = (left / 100).toFixed(2) + ' ' + currency;
    }

    const message = left > 0
      ? (he ? 'עוד ' + amount + ' ומקבלים משלוח חינם' : "You're " + amount + ' away from free shipping')
      : (he ? 'ההזמנה שלך זכאית למשלוח חינם' : 'Your order ships free');

    root.innerHTML =
      '<style>' +
      ':host{display:block;padding:12px 0 16px}' +
      ':host([hidden]){display:none}' +
      'p{margin:0 0 8px;font-size:.875rem;font-weight:600;text-align:center}' +
      '.track{height:6px;border-radius:99px;background:rgba(0,0,0,.1);overflow:hidden}' +
      '.fill{height:100%;border-radius:99px;background:#17643a;transition:width .3s ease}' +
      '</style>' +
      '<p></p><div class="track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '">' +
      '<div class="fill" style="width:' + pct + '%"></div></div>';
    root.querySelector('p').textContent = message;
  }
}

if (!customElements.get('am-ship-bar')) {
  customElements.define('am-ship-bar', AmShipBar);
}

document.addEventListener('click', async (event) => {
  const target = event.target instanceof Element ? event.target.closest('[data-am-add]') : null;
  if (!target) return;
  event.preventDefault();
  if (target.hasAttribute('disabled')) return;
  target.setAttribute('disabled', '');

  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
  try {
    const added = await fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ items: [{ id: Number(target.getAttribute('data-am-add')), quantity: 1 }] }),
    });
    if (!added.ok) throw new Error('add failed');
    const cart = await (await fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    document.dispatchEvent(
      new CartUpdateEvent(cart, 'am-cart-addon', { itemCount: cart.item_count, source: 'am-cart-addon' })
    );
  } catch (error) {
    target.removeAttribute('disabled');
  }
});
